"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require("redux");

var _reduxDynamic = require("@bone/redux-dynamic");

/**
 * 可以动态添加/移除reducer的createStore
 * 使用的时候代替redux中的createStore
 */
exports.default = (0, _reduxDynamic.reducerDynamic)(_redux.createStore);


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_bone-mv@0.1.20@@bone/bone-mv/lib/createStore.js
// module id = 2546
// module chunks = 4